import { defineCatalogue } from '../../../i18n';

export const acceptCatalogue = defineCatalogue(
  {
    'label.organisation': 'Organização',
    'label.campaign': 'Campanha',
    'label.role': 'Seu papel',
    'label.inviter': 'Enviado por',
    'role.TENANT_ADMIN': 'Administrador',
    'role.CAMPAIGN_ANALYST': 'Analista',
    'action.decline': 'Recusar',
    'action.home': 'Acessar sua organização',
    'action.retry': 'Tentar novamente',
    loading: 'Abrindo o convite',
    failed: 'Não foi possível abrir o convite. Tente novamente.',
    'blocked.expired': 'Este convite expirou.',
    'blocked.withdrawn': 'Este convite foi cancelado.',
    'blocked.accepted': 'Você já aceitou este convite.',
    'blocked.noLongerValid': 'Este convite não é mais válido.',
    'blocked.ask': 'Peça um novo convite a {sender}.',
    'blocked.askUnnamed': 'Peça um novo convite a quem enviou.',
    declineFailed: 'Não foi possível recusar. Tente novamente.',
    expires: 'Expira em {date}',
  },
  {
    'label.organisation': 'Organisation',
    'label.campaign': 'Campaign',
    'label.role': 'Your role',
    'label.inviter': 'Sent by',
    'role.TENANT_ADMIN': 'Administrator',
    'role.CAMPAIGN_ANALYST': 'Analyst',
    'action.decline': 'Decline',
    'action.home': 'Go to your organisation',
    'action.retry': 'Try again',
    loading: 'Opening the invitation',
    failed: 'Could not open the invitation. Try again.',
    'blocked.expired': 'This invitation has expired.',
    'blocked.withdrawn': 'This invitation was cancelled.',
    'blocked.accepted': 'You already accepted this invitation.',
    'blocked.noLongerValid': 'This invitation is no longer valid.',
    'blocked.ask': 'Ask {sender} for a new invitation.',
    'blocked.askUnnamed': 'Ask the sender for a new invitation.',
    declineFailed: 'Could not decline. Try again.',
    expires: 'Expires {date}',
  },
);

export const ta = acceptCatalogue.t;
